const getters = {
    contentHeight: state => state.system.contentHeight,
    userInfo:state => state.system.userInfo,
  }
  export default getters
  